export enum SettlementInstructionField {
  INSTRUCTING_PARTY = 'instructingParty',
  DELIVERING_PARTY = 'deliveringParty',
  RECEIVING_PARTY = 'receivingParty',
  COUNTER_PARTY = 'counterParty',
  ASSET = 'asset',
  SETTLEMENT_QUANTITY = 'settlementQuantity',
  INTENDED_SETTLEMENT_DATE = 'intendedSettlementDate',
  SETTLEMENT_AMOUNT = 'settlementAmount',
  SETTLEMENT_AMOUNT_CURRENCY = 'settlementAmountCurrency',
  ACCRUED_INTEREST_INDICATOR = 'accruedInterestIndicator',
  TRADE_DATE = 'tradeDate',
  COMMON_TRADE_ID = 'commonTradeId',
  SETTLING_CAPACITY_CODE = 'settlingCapacityCode',
  CSD_HOLD = 'csdHold',
  CORPORATE_ACTION_EVENT_IDENTIFICATION = 'corporateActionEventIdentification',
  LINKAGES_PROCESSING_POSITION_CODE = 'linkagesProcessingPositionCode',
  LINKED_INSTRUCTING_PARTY_TRANSACTION_ID = 'linkedInstructingPartyTransactionId',
  MATCHING_STATUS_CODE = 'matchingStatusCode',
  TRADE_PRICE = 'dealPriceValueAmount',
  TRADE_RATE = 'dealPriceValueRate',
  TRADE_TIME = 'tradeTime',
  REPORTING_CODE = 'reportingCode',
  PLACE_OF_TRADE_TYPE = 'placeOfTradeTypeCode',
}

export enum SettlementInstructionMatchingStatus {
  MATCHED = 'MATCHED',
  UNMATCHED = 'UNMATCHED',
}

export enum SettlementInstructionTypeSelector {
  DVP = 'dvp',
  RVP = 'rvp',
  DFP = 'dfp',
  RFP = 'rfp',
  PMO = 'pmo',
  RMO = 'rmo',
  CA_DVP = 'ca-dvp',
  CA_RVP = 'ca-rvp',
  CA_DFP = 'ca-dfp',
  CA_RFP = 'ca-rfp',
  CA_PMO = 'ca-pmo',
  CA_RMO = 'ca-rmo',
  CC_DEPOSIT = 'cc-deposit',
  CC_WITHDRAWAL = 'cc-withdrawal',
  CC_INTRA_WITHDRAWAL = 'cc-intra-withdrawal',
  AT = 'at',
  CROSS_CSD_DFP = 'cross-csd-dfp',
  CROSS_CSD_RFP = 'cross-csd-rfp',
  ON_EXCHANGE_DVP = 'on-exchange-dvp',
  ON_EXCHANGE_RVP = 'on-exchange-rvp',
  ISSUANCE = 'issuance',
  DEISSUANCE = 'deissuance',
  ASSET_SUBBALANCE_TRANSFER = 'asset-sub-balance-transfer',
}

export enum AssetFields {
  IS_ASSET_LISTED = 'isAssetListed',
  ISIN = 'isin',
  LOCAL_SECURITY_ID = 'localSecurityId',
  LONG_DESCRIPTION = 'longDescription',
  DENOMINATION_CURRENCY = 'denominationCurrency',
  NOMINAL_VALUE = 'nominalValue',
  INDUSTRY_SECTOR = 'industrySector',
  GOVERNING_LAW = 'governingLaw',
  ISSUER = 'issuer',
  TOTAL_ALLOWED_QUANTITY = 'totalAllowedQuantity',
  INACTIVATION_DATE = 'inactivationDate',
  ACCRUED_INTEREST_FROM_DATE = 'accruedInterestFromDate',
  INTEREST_CURRENCY = 'interestCurrency',
  INTEREST_FREQUENCY = 'interestFrequency',
  INTEREST_TYPE = 'interestType',
  ANNUAL_INTEREST_RATE = 'annualInterestRate',
  FIRST_INTEREST_PERIOD_END_DATE = 'firstInterestPeriodEndDate',
  LAST_REGULAR_INTEREST_PERIOD_END_DATE = 'lastRegularInterestPeriodEndDate',
  DAY_COUNT_METHOD = 'dayCountMethod',
  MATURITY_DATE = 'maturityDate',
  EXPIRATION_DATE = 'expirationDate',
  INTEREST_PAYMENT = 'interestPayments',
  TXHASH = 'txhash',
  CHANGE_STATUS = 'changeStatus',
  TRADING_STATUS = 'tradingStatus',
  MODIFICATION_DATE_TIME = 'modificationDateTime',
}

export enum LegalEntityFields {
  INCORPORATION_COUNTRY = 'incorporationCountry',
}

export enum AssetType {
  BOND = 'D',
  EQUITY = 'E',
}

export enum CurrencyFields {
  CODE = 'code',
}
